import { Catalog } from '@df/catalog/catalog.interfaces';
import { ISites } from '@df/core/df-core.interfaces';
export namespace NMultisiteSwitchModal {
    /**
     * Component id and block url
     */
    export const componentId = 'multisite-switch';

    /**
     * Multiste modal bLock data
     */
    export type IBlockData = Catalog.IBlockData<IBlockContent>;
    /**
     * Modal block content
     */
    export interface IBlockContent {
        /**
         * Modal title
         */
        title: string;
        /**
         * Modal subtitle
         */
        subtitle?: string;
        /**
         * Close button subtitle
         */
        closeBtnCopy?: string;
        /**
         * Stores list
         */
        stores: IBlockContentStore[];
    }
    /**
     * Modal block content / store
     */
    export interface IBlockContentStore {
        // site id
        siteId: keyof ISites;
        // icon image
        icon?: string;
        //  name
        title: string;
    }
}
